import axios from "axios";
import React from "react";
import { useState, useEffect } from "react";
import Genres from "../../components/Genres";
import CustomPagination from "../../components/Pagination/CustomPagination";
import SingleContent from "../../components/SingleContent/SingleContent";
import useGenres from "../../components/hooks/useGenre";

const Films = () => {
    const [page, setPage] = useState(1);
    const [content, setContent] = useState([]);
    const [numOfPages, setNumOfPages] = useState();
    const [selectedGenres, setselectedGenres] = useState([]);
    const [genres, setgenres] = useState([]);
    const genreForUrl = useGenres(selectedGenres);

    const fetchFilms = async () => {
        const { data } = await axios.get(`https://api.themoviedb.org/3/discover/movie?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&sort_by=popularity.desc&include_adult=true&include_video=false&page=${page}&with_genres=${genreForUrl}`);

        setContent(data.results);
        setNumOfPages(data.total_pages);
    };

    useEffect(() => {
        fetchFilms();
        window.scroll(0, 0);
        // eslint-disable-next-line
    }, [page, genreForUrl]);

    return (
        <div>
            <span className="pageTitle">Movies</span>
            {<Genres type="movie" selectedGenres={selectedGenres} setselectedGenres={setselectedGenres} genres={genres} setGenres={setgenres} setPage={setPage} />}
            <div className="trending">{content && content.map(c => <SingleContent key={c.id} id={c.id} poster={c.poster_path} title={c.title} date={c.release_date} media_type="movie" vote_average={c.vote_average} />)}</div>
            {numOfPages > 1 && <CustomPagination setpage={setPage} numOfPages={numOfPages} />}
        </div>
    );
};

export default Films;
